function preventMouseMove(event) {
  const { isDragging } = window.Widget.stateController;

  if (!isDragging) {
    event.stopPropagation();
  }
}

export { preventMouseMove };
